export default __webpack_public_path__ + "assets/fonts/a43a2acb4ccab88dcb983098838b56c1.woff";